import * as React from "react";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "@egds/react-core/images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "@egds/react-core/layout-grid";
import { UitkCardLink } from "@egds/react-core/cards";
import { UitkSheet, UitkSheetTransition } from "@egds/react-core/sheet";
import { UitkSpacing } from "@egds/react-core/spacing";
import { UitkText } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { mapTracking } from "../EGMapsUtils";

export const EGMapDisplayCard: React.FC<any> = (props) => {
  const { componentName, place, href, isVisible, children, ...rest } = props;
  const track = useClickTracker();

  if (!place || !isVisible) {
    return null;
  }

  const onClickCapture = () => {
    mapTracking(componentName, track, "fullscreen.hotel-card");
  };

  if (children && typeof children === "function") {
    return children(props);
  }

  return (
    <UitkSheetTransition isVisible={true}>
      <UitkSheet className="MapHotelCard" isVisible={true} {...rest}>
        <UitkLayoutGrid columns={4}>
          <UitkLayoutGridItem colSpan={1}>
            <UitkFigure ratio={UitkFigureAspectRatioType.R16_9}>
              <UitkImage alt={place.placeName} src={place.imageUrl} placeholderImage />
            </UitkFigure>
          </UitkLayoutGridItem>
          <UitkLayoutGridItem colSpan={3}>
            <UitkSpacing padding="three">
              <UitkLayoutFlex direction="column" justifyContent="center">
                <UitkLayoutFlexItem>
                  <UitkText size={400} weight={"medium"} overflow={"truncate"} inline={true}>
                    {place.placeName}
                  </UitkText>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <UitkText size={300}>
                    <Rating place={place} />
                  </UitkText>
                </UitkLayoutFlexItem>
                {place.formattedPrice && (
                  <UitkLayoutFlexItem>
                    <UitkText size={400} weight={"medium"} inline={true}>
                      {place.formattedPrice}
                    </UitkText>
                  </UitkLayoutFlexItem>
                )}
              </UitkLayoutFlex>
            </UitkSpacing>
          </UitkLayoutGridItem>
          <UitkCardLink>
            <a href={href} onClickCapture={onClickCapture} title={`Open ${place.placeName} hotel page`}>
              {place.placeName}
            </a>
          </UitkCardLink>
        </UitkLayoutGrid>
      </UitkSheet>
    </UitkSheetTransition>
  );
};

const Rating: React.FC<{
  place: any;
}> = ({ place: { overallReviewRating, reviewCount, localizedSubtitle }, ...rest }) => {
  if (!localizedSubtitle && (!overallReviewRating || !reviewCount)) {
    return null;
  }

  return <span {...rest}>{localizedSubtitle ? localizedSubtitle : `${overallReviewRating} ${reviewCount}`}</span>;
};
